/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { HelpUrlDto } from '../models/help-url-dto';

@Injectable({
  providedIn: 'root',
})
export class HelpUrlApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getHelpUrlByUrl
   */
  static readonly GetHelpUrlByUrlPath = '/api/HelpUrl/get-helpurl-by-url';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHelpUrlByUrl$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpUrlByUrl$Plain$Response(params?: {
    url?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<HelpUrlDto>> {

    const rb = new RequestBuilder(this.rootUrl, HelpUrlApiService.GetHelpUrlByUrlPath, 'get');
    if (params) {
      rb.query('url', params.url, {});
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpUrlDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getHelpUrlByUrl$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpUrlByUrl$Plain(params?: {
    url?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<HelpUrlDto> {

    return this.getHelpUrlByUrl$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpUrlDto>) => r.body as HelpUrlDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHelpUrlByUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpUrlByUrl$Response(params?: {
    url?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<HelpUrlDto>> {

    const rb = new RequestBuilder(this.rootUrl, HelpUrlApiService.GetHelpUrlByUrlPath, 'get');
    if (params) {
      rb.query('url', params.url, {});
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpUrlDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getHelpUrlByUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpUrlByUrl(params?: {
    url?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<HelpUrlDto> {

    return this.getHelpUrlByUrl$Response(params).pipe(
      map((r: StrictHttpResponse<HelpUrlDto>) => r.body as HelpUrlDto)
    );
  }

  /**
   * Path part for operation getDefaultHelpUrl
   */
  static readonly GetDefaultHelpUrlPath = '/api/HelpUrl/get-default-helpUrl';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDefaultHelpUrl$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaultHelpUrl$Plain$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<HelpUrlDto>> {

    const rb = new RequestBuilder(this.rootUrl, HelpUrlApiService.GetDefaultHelpUrlPath, 'get');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpUrlDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDefaultHelpUrl$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaultHelpUrl$Plain(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<HelpUrlDto> {

    return this.getDefaultHelpUrl$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<HelpUrlDto>) => r.body as HelpUrlDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDefaultHelpUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaultHelpUrl$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<HelpUrlDto>> {

    const rb = new RequestBuilder(this.rootUrl, HelpUrlApiService.GetDefaultHelpUrlPath, 'get');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HelpUrlDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDefaultHelpUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaultHelpUrl(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<HelpUrlDto> {

    return this.getDefaultHelpUrl$Response(params).pipe(
      map((r: StrictHttpResponse<HelpUrlDto>) => r.body as HelpUrlDto)
    );
  }

}
